
import axios from "../../utils/axios";

const BASE_URL = "/contract-categories";

const handleError = (error) => ({
  success: false,
  data: null,
  message:
    error.response?.data?.message ||
    error.response?.data?.error ||
    error.message ||
    "Something went wrong. Please try again.",
  errors: error.response?.data?.errors || {},
  status: error.response?.status || null,
});

const handleSuccess = (response, fallbackMessage) => ({
  success: true,
  data: response.data?.data ?? response.data,
  message: response.data?.message || fallbackMessage,
  meta: response.data?.meta || null,
});

const contractCategoryService = {
  // Get all contract categories
  async getAll(params = {}) {
    try {
      const response = await axios.get(BASE_URL, { params });
      return handleSuccess(
        response,
        "Contract categories fetched successfully."
      );
    } catch (error) {
      return handleError(error);
    }
  },

  // Get one contract category
  async getById(id) {
    try {
      const response = await axios.get(
        `${BASE_URL}/${encodeURIComponent(id)}`
      );
      return handleSuccess(
        response,
        "Contract category fetched successfully."
      );
    } catch (error) {
      return handleError(error);
    }
  },

  // Create a contract category
  async create(categoryData) {
    try {
      const response = await axios.post(BASE_URL, categoryData);
      return handleSuccess(
        response,
        "Contract category created successfully."
      );
    } catch (error) {
      return handleError(error);
    }
  },

  // Update a contract category
  async update(id, categoryData) {
    try {
      const response = await axios.put(
        `${BASE_URL}/${encodeURIComponent(id)}`,
        categoryData
      );
      return handleSuccess(
        response,
        "Contract category updated successfully."
      );
    } catch (error) {
      return handleError(error);
    }
  },

  // Delete a contract category
  async delete(id) {
    try {
      const response = await axios.delete(
        `${BASE_URL}/${encodeURIComponent(id)}`
      );
      return handleSuccess(
        response,
        "Contract category deleted successfully."
      );
    } catch (error) {
      return handleError(error);
    }
  },

  // Change category status
  async updateStatus(id, status) {
    try {
      const response = await axios.patch(
        `${BASE_URL}/${encodeURIComponent(id)}/status`,
        { status }
      );
      return handleSuccess(
        response,
        "Contract category status updated successfully."
      );
    } catch (error) {
      return handleError(error);
    }
  },
};

export default contractCategoryService;
